import { tv, VariantProps } from '@/utils/tv'

export const mapVariant = tv({
  slots: {
    base: ['relative'],
    container: ['lg:container-fluid'],
    heading: [
      'lg:absolute lg:z-20 lg:top-0',
      'bg-blue-500',
      'px-6 py-12 lg:p-12',
      'w-full lg:max-w-md'
    ],
    title: ['text-white', 'mb-2'],
    address: ['text-white'],
    map: ['w-full h-64 sm:h-80 lg:h-[460px]', 'bg-gray-50']
  }
})

export type MapVariantProps = VariantProps<typeof mapVariant>
